import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncProcessorService } from '@vending/sync-engine-client';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { PriorityModel } from 'src/app/models/settings/priority';
import { ErrorService } from 'src/packages/mitsBasics';
import { EventsService } from 'src/packages/mitsBasics';
import { OfflineDataService } from 'src/packages/mitsBasics';

@Injectable({
  providedIn: 'root',
})
export class PriorityService extends OfflineDataService<PriorityModel> {
  constructor(
    public indexedDBService: NgxIndexedDBService,
    public syncProcessor: SyncProcessorService,
    public http: HttpClient,
    public errorService: ErrorService,
    public events: EventsService
  ) {
    super(
      indexedDBService,
      syncProcessor,
      'System::Priority',
      http,
      errorService,
      events,
      'system/priorities/',
      'system_priority',
      ['created_at', 'updated_at', 'created_by_id'],
      []
    );
  }

  /**
   * Name des Icons für die Klasse
   * @return {string}
   */
  public get iconName(): string {
    return 'contract';
  }
}
